  <div [config]="{ show: true, backdrop: 'static' }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal"
    class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div>
            <h5>{{title}}</h5>
            <p class="mt-2">{{surveyError}}</p>
            <div class="text-right mt-3">
              <button class="btn-design small outline px-3 mr-2"
                (click)="hideModal()">{{cancel}}</button>
              <button class="btn-design small filled px-3"
                (click)="ActivateAction()"> {{ok}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>